import { useState } from "react";
import { KeyRound, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiErrorDetail } from "@/lib/api";

const field = "w-full rounded-xl bg-white/5 border border-white/15 px-4 py-3 text-white outline-none focus:border-[var(--sun)]";

export const ChangePassword = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return setError("New passwords don't match");
    setLoading(true);
    setError("");
    try {
      await http.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password updated");
      setOpen(false);
      setF({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button data-testid="admin-change-password-btn" onClick={() => setOpen(true)} className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors"><KeyRound size={18} /> <span className="hidden sm:inline">Change password</span></button>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm grid place-items-center px-5" onClick={() => setOpen(false)}>
          <form data-testid="change-password-modal" onSubmit={submit} onClick={(e) => e.stopPropagation()} className="w-full max-w-md rounded-2xl bg-[var(--surface)] border border-white/10 p-8 space-y-4">
            <div className="flex items-center justify-between">
              <h2 className="font-display font-black uppercase text-3xl">Change password</h2>
              <button type="button" data-testid="change-password-close" onClick={() => setOpen(false)} className="text-slate-400 hover:text-white"><X /></button>
            </div>
            <input type="password" required placeholder="Current password" data-testid="change-password-current" className={field} value={f.current_password} onChange={set("current_password")} />
            <input type="password" required minLength={8} placeholder="New password (8+ characters)" data-testid="change-password-new" className={field} value={f.new_password} onChange={set("new_password")} />
            <input type="password" required minLength={8} placeholder="Confirm new password" data-testid="change-password-confirm" className={field} value={f.confirm} onChange={set("confirm")} />
            {error && <p data-testid="change-password-error" className="text-sm text-red-400">{error}</p>}
            <button type="submit" disabled={loading} data-testid="change-password-submit" className="w-full flex items-center justify-center gap-2 rounded-full bg-[var(--sun)] text-[var(--ink)] py-3.5 font-display font-bold uppercase tracking-wider disabled:opacity-70">
              {loading && <Loader2 className="animate-spin" size={16} />} Update password
            </button>
          </form>
        </div>
      )}
    </>
  );
};
